"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getComputedStyles_1 = require("./getComputedStyles");
/**
 * Check if the given element is using right-to-left layout
 * @param element An HTML element to check
 * @returns True if the given element is using right-to-left layout, otherwise false
 */
function isRtl(element) {
    return getComputedStyles_1.getComputedStyle(element, 'direction') == 'rtl';
}
exports.default = isRtl;
//# sourceMappingURL=isRtl.js.map